export default {
	queryCondition: '查询条件',
	applyNo: '业务单号',
	pleaseEnter: '请输入',
	messageType: '消息类型',
	pleaseSelect: '请选择',
	messageTypeProduction: '生产',
	messageTypeConsumption: '消费',
	selectDate: '请选择日期',
	createDate: '创建日期',
	queryResult: '查询结果',
	createTime: '创建时间',
	parameters: '参数',
	retryNum: '重试次数',
	errorMessage: '错误信息',
	operate: '操作',
	edit: '修改',
	retry: '重试',
	pleaseEnterContent: '请输入内容',
	confirm: '确定',
	cancel: '取消',
	saveSuccess: '保存成功',
	operateSuccessfully: '操作成功',
	fundingRequestList: '我的经费申请列表'
};
